/**
 * 部屋のタイムアウト設定が取れたときに撒く。取れなかったときも撒く
 * （enabled:false で「切らない」が確定するので、それも結果のうち）。
 *
 * {
 *     type: SET_SESSION_TIMEOUT_CONFIG,
 *     config: ISessionTimeoutConfig
 * }
 */
export const SET_SESSION_TIMEOUT_CONFIG = 'SET_SESSION_TIMEOUT_CONFIG';
/**
 * 残り秒数の更新。1秒ごとに撒く。
 *
 * 「いつ切れるか」ではなく「あと何秒か」を持つ理由:
 *   時計の表示・予告の判定・退出の判定がすべて同じ数字を見るので、
 *   3か所がそれぞれ現在時刻を取ると、1秒ずれた状態が同時に存在しうる。
 *
 * {
 *     type: SET_SESSION_TIMEOUT_REMAINING,
 *     idleLeftMs: number,
 *     maxLeftMs: number
 * }
 */
export const SET_SESSION_TIMEOUT_REMAINING = 'SET_SESSION_TIMEOUT_REMAINING';
/**
 * 予告ダイアログの表示/非表示。
 *
 * reason は何のタイマーで出したか。'idle' は「続ける」で延長できるが、
 * 'max' は延長できない（30分を超えさせないため）。
 *
 * {
 *     type: SET_SESSION_TIMEOUT_WARNING,
 *     reason: 'idle' | 'max' | null
 * }
 */
export const SET_SESSION_TIMEOUT_WARNING = 'SET_SESSION_TIMEOUT_WARNING';
